module.exports = __webpack_public_path__ + "img/7.7.Chla.eeb02166.png";